module.exports = __webpack_public_path__ + "static/media/NTC2025-DAY2.7e4e77de.jpg";